<template>
  <div class="custom-drop-down" @click="setOpened">
    <div class="label" :class="isOpened ? 'opened' : null">
      <input
        type="text"
        :placeholder="placeholder === '' ? 'Select' : placeholder"
        v-model.trim="optionsFilter"
        @input="$emit('set-opened', id)"
        @focus="$emit('set-opened', null)"
      />
      <img
        :src="$images.dropdownArrow"
        alt="dropdownarrow"
        :class="isOpened ? 'rotate' : null"
      />
    </div>
    <div class="options" v-show="isOpened">
      <div class="x" @click="removeSelection">
        {{ $t("dropDown.clearSelected")
        }}<span class="material-icons">clear</span>
      </div>
      <div class="x" @click="handleSelectAll">{{ $t('dropDown.selectAll') }}<span class="material-icons">done</span></div>
      <div
        class="each-option"
        v-for="(option, i) in filteredOptions"
        :key="i"
        @click.stop
      >
        <input
          type="checkbox"
          :id="'input-' + id + '-' + i"
          @input="setValue($event.target.checked, option.usr_id, option.tag_id)"
          :checked="option.isChecked"
        />
        <label :for="'input-' + id + '-' + i">{{ option[displayKey] }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    id: {
      type: Number,
      default: 1,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Select",
    },
    displayKey: {
      type: String,
    },
    isOpened: {
      type: Boolean,
      default: false,
    },
    pqt_id: {
      type: Number,
    },
    selectAll: {
      type: Boolean,
    },
  },
  data() {
    return {
      optionsFilter: "",
      neoOptions: JSON.parse(JSON.stringify(this.options)),
    };
  },
  computed: {
    ...mapState(["currentTagDropDown"]),
    checkedOptions() {
      return this.neoOptions.filter((option) => option.isChecked);
    },

    filteredOptions() {
      return this.neoOptions.filter((option) => {
        if (
          option[this.displayKey]
            .toLowerCase()
            .indexOf(this.optionsFilter.toLowerCase()) !== -1
        ) {
          return option;
        }
      });
    },
  },
  watch: {
    checkedOptions: {
      deep: true,
      handler(val) {
        this.emitValue();
      },
    },
    selectAll(val) {
      if (val) {
        this.neoOptions.map((option) => {
          return (option.isChecked = true);
        });
        this.$emit("get-value", this.neoOptions);
      } else {
        this.neoOptions.map((option) => {
          return (option.isChecked = false);
        });
        this.$emit("get-value", []);
      }
    },
    options(val) {
     this.neoOptions = JSON.parse(JSON.stringify(this.options))
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["setCurrentTagDropDownId"]),
    init() {
      let int;
      int = setInterval(() => {
        if (this.neoOptions != this.options) {
          this.neoOptions = JSON.parse(JSON.stringify(this.options));
          console.log(this.neoOptions);
          clearInterval(int);
        }
      }, 500);
    },
    setOpened() {
      let oldId = this.currentTagDropDown;
      this.setCurrentTagDropDownId(this.id);
      if (oldId && oldId != this.currentTagDropDown) {
        this.neoOptions.map((option) => {
          return (option.isChecked = false);
        });
      }
      this.$emit("set-opened", this.isOpened ? null : this.id);
    },
    emitValue() {
      if (this.pqt_id) {
        let pqaIdArray = [];
        for (let i = 0; i < this.checkedOptions.length; i++) {
          pqaIdArray.push(this.checkedOptions[i].pqa_id);
        }

        this.$emit("get-value", {
          pqt_id: this.pqt_id,
          answers: pqaIdArray,
        });
      } else {
        this.$emit("get-value", this.checkedOptions);
      }
    },
    removeSelection() {
      for (let i = 0; i < this.neoOptions.length; i++) {
        this.$set(this.neoOptions[i], "isChecked", false);
      }
    },
    setValue(value, i, tag_id = null) {
      this.neoOptions.forEach((element, index) => {
        if (element.usr_id == i && !tag_id) {
          let el = JSON.parse(JSON.stringify(element));
          el.isChecked = value;
          this.neoOptions.splice(index, 1, el);
        }
        if (tag_id && element.tag_id == tag_id) {
          let el = JSON.parse(JSON.stringify(element));
          el.isChecked = value;
          this.neoOptions.splice(index, 1, el);
        }
      });
    },
    handleSelectAll() {
      console.log(this.neoOptions);
      for (let i = 0; i < this.neoOptions.length; i++) {
        this.$set(this.neoOptions[i], "isChecked", true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
input {
  outline: none;
}
.custom-drop-down {
  position: relative;
  font-family: "Roboto";
  display: inline-block;
  background: #f3f3f3;
  width: 180px;
  border-radius: 5px 5px 0 0;
  .label {
    display: flex;
    align-items: center;
    width: 100%;
    z-index: 10;
    input[type="text"] {
      background: none;
      border: none;
      padding-top: 3px;
      padding-left: 10px;
      font-size: 1em;
    }
    ::placeholder {
      color: black;
      opacity: 1;
      font-size: 1em;
    }
    &.opened {
      background-color: #ffe2e8;
      border-radius: 5px 5px 0 0;
    }
  }
  .options {
    width: 100%;
    position: absolute;
    max-height: 200px;
    overflow-y: auto;
    background: #f3f3f3;
    padding: 7px 0 7px 7px;
    border-radius: 0 0 5px 5px;
    overflow: auto;
    z-index: 11;
    .each-option {
      display: flex;
      align-items: center;
    }
    input[type="checkbox"] {
      min-width: 16px;
      min-height: 16px;
    }
  }
}
select {
  appearance: none;
  background: #f3f3f3;
  border-radius: 5px;
  font-size: 1em;
  padding: 9px 65px 9px 8px;
  outline: none;
  border: none;
  width: 100%;
  height: 100%;
}
img {
  position: absolute;
  right: 13px;
  top: 16px;
  transform: translateY(-50%);
  cursor: pointer;
  &.rotate {
    transform: rotate(180deg) translateY(50%);
  }
}
.x {
  display: flex;
  align-items: center;
  padding-left: 4px;
  margin-bottom: 5px;
  color: #9d9d9d;
  cursor: pointer;
  .material-icons {
    font-size: 18px;
    margin-top: 1px;
    margin-left: 5px;
  }
}
</style>